import type { RootState } from 'state/store'

export const selectTotalPoints = (state: RootState) => state.points.total
export const selectPointsLevel = (state: RootState) => state.points.level
